import { Box, Divider } from '@mui/material'
import styles from './index.module.scss'

/** @param {{ footer: import('react').ReactNode }} props */
export function FloatingMenuPopoverFooter({ footer }) {
  if (!footer) return null
  return (
    <>
      <Divider className={styles.footerDivider} />
      <Box className={styles.footerSlot}>{footer}</Box>
    </>
  )
}
